import React from 'react';
/*import Select from 'react-select';*/
import {Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import Presenter from '../../../presenter.js';
import RequestProperties from '../../request.props.js';
import FormHelper from '../../form.js';
import Messagev2 from '../../../../config/message_v2.js'; 
import {ButtonValidation, ButtonCancel} from '../../../../component/Button.js'
import { toast } from 'react-toastify';
import SelectQuery from '../../../../component/SelectQuery.js';

export default class ModalMaintenanceRequest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Asset       : '',
      Service     : '',
      Description : '',
      is_process  : false,
    }
    
    // Request Maintenance
    this.onRequest        = this.onRequest.bind(this)
    this.onRequestSuccess = this.onRequestSuccess.bind(this)
    this.onRequestFailed  = this.onRequestFailed.bind(this)
  }

  generateLabel(MasterReducer, type) {
    let OptionAutoComplete = [];
    for(let i = 0 ; i < MasterReducer.length; i++) {
      OptionAutoComplete.push(
        { value: MasterReducer[i].Alias, label: MasterReducer[i].Name }
      )
    }
    return OptionAutoComplete
  }

  onRequest() {
    if(!FormHelper.ValidateFormRequestMaintenance(this.state, Messagev2)) {
      return
    }
    this.setState({is_process: true})
    Presenter.RegisterRequestMaintenance(
      RequestProperties.RegisterRequestMaintenance(
        this, 
        this.onRequestSuccess, 
        this.onRequestFailed
      )
    )
  }

  onRequestSuccess(params, response) {
    this.setState({
      Service     : "",
      Description : "",
      is_process  : false,
    })

    this.props.toggleTab('2')
    this.props.updateRow()
    this.props.closeModal();
    toast.success('Maintenance has been successfully added')
  }

  onRequestFailed(error) {
    this.setState({is_process: false})
    this.props.closeModal();
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.asset !== '' || nextProps.asset !== null || nextProps.asset !== undefined) {
      this.setState({Asset: nextProps.asset.assetAlias})
    }
  }

  render() {
    const props = this.props;
    const {is_process} = this.state

    if(props.asset === '' || props.asset === null || props.asset === undefined) {
      return(null)
    }

    return (
      <Modal isOpen={props.modalMaintenanceRequest} toggle={()=>props.closeModal()}>
        <ModalHeader toggle={()=>props.closeModal()}>Request Maintenance</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="form-group col-sm-12">
              <label>Asset/ Tools</label>
              <input type="text" className="form-control" value={decodeURIComponent(props.asset.assetName)} readOnly/>
            </div>
            <div className="form-group col-sm-6">
              <label>Maintenance Status</label>
              <input type="text" className="form-control" value="Good" readOnly/>
            </div>
            <div className="form-group col-sm-6">
              <label className="required">Request Type</label>
              <SelectQuery 
                placeholder="Type Maintenance"
                value={this.state.Service}
                onChange={(e) => this.setState({Service: e.value})}
                urlKey="read-maintenance-type-autocomplete"
                valKey="Alias"
                valLabel="Name"
                isCreatable={false}
                UserReducer={this.props.UserReducer}
              />
            </div>
            <div className="form-group col-sm-12">
              <label className="required">Description</label>
              <textarea 
                className="form-control" 
                cols="30" rows="3" 
                value={this.state.Description}
                onChange={(e)=>this.setState({Description: e.target.value})}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonCancel onClick={()=>props.closeModal()}>Cancel</ButtonCancel>
          <ButtonValidation is_process={is_process} onClick={()=>this.onRequest()} disabled={this.state.disabled}>Request</ButtonValidation>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/maintenance/helper/component/Modal/ModalMaintenanceRequest.js